import { Box } from '@mui/material';
import BackdropComponent from '../../../../../components/Backdrop/BackdropComponent';
import { HeaderField } from '../types/technicalVisit.types';
import HeaderSection from './HeaderSection';

type TechnicalVisitHeaderDataProps = {
    contractFields: HeaderField[];
    establishmentFields: HeaderField[];
    responsibleFields: HeaderField[];
    isFetching: boolean;
    titles: {
        contractData: string;
        establishmentData: string;
        responsibleData: string;
    };
};

const TechnicalVisitHeaderData = ({
    contractFields,
    establishmentFields,
    responsibleFields,
    isFetching,
    titles
}: TechnicalVisitHeaderDataProps) => (
    <Box sx={{ backgroundColor: 'white', p: 3 }}>
        <HeaderSection title={titles.contractData} fields={contractFields} />
        <HeaderSection title={titles.establishmentData} fields={establishmentFields} />
        <HeaderSection title={titles.responsibleData} fields={responsibleFields} />
        <BackdropComponent fetching={isFetching} />
    </Box>
);

export default TechnicalVisitHeaderData;
